/**
 * Splits an array into smaller chunks of a given size.
 *
 * @example
 * chunkArray([1,2,3,4,5], 2) // [[1,2], [3,4], [5]]
 *
 * @param arr The input array to chunk
 * @param size The maximum size of each chunk (must be > 0)
 * @returns Array of chunks
 */
export function chunkArray<T>(arr: T[], size: number): T[][] {
  if (size <= 0) {
    throw new Error('chunk size must be greater than 0');
  }

  const RESULT: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    RESULT.push(arr.slice(i, i + size));
  }

  return RESULT;
}
